// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"69540e09e73ff62c20ec","524":"38ad3b798a59d11cad6f","927":"7800e7502ce54cde38f5"}[chunkId] + ".css";
};